import Portal from "../portal";
import { useMount } from "./useMount";
import { Layout } from "./Layout";
import useResizeHeightContent from "../../../../lib/hooks/useResizeHeightContent";

interface ComplexAnimatedModalProps {
  opened: boolean;
  onClose: () => void;
  children: React.ReactElement;
  isSecondModal?: boolean;
  offsetY: number;
}

export const ComplexAnimatedModal = ({
  opened,
  isSecondModal,
  offsetY,
  onClose,
  children,
}: ComplexAnimatedModalProps) => {
  const { mounted } = useMount({ opened });

  useResizeHeightContent();

  // useEffect(() => {
  //   if (opened && !isSecondModal) {
  //     const setBodyOverflow = () => {
  //       // document.body.style.overflow = "auto";
  //       // document.body.style.touchAction = "auto";
  //     };
  //     // document.body.style.overflow = "hidden";
  //     // document.body.style.touchAction = "none";

  //     return () => {
  //       setBodyOverflow();
  //     };
  //   }
  // }, [opened]);

  if (!mounted) {
    return null;
  }

  return (
    <Portal>
      <Layout onClose={onClose} opened={opened} offsetY={offsetY}>
        {children}
      </Layout>
    </Portal>
  );
};
